import { anyLeague } from "../../../classificators/league/index.js";
import { DataSection, PitchData, RankingScopeContext, ResultDataNew } from "../../../enums/index.js";
import resultsSliceForPitchType from "../../../classificators/resultsSlice/resultsSliceForPitchType.js";
import satisfiesAll from "../../../classificators/satisfiesAll.js";
import pitchingScopeContext from "../../../classificators/resultsSlice/pitchingScopeContext.js";
import sessionWithNewScoring from "../../../classificators/session/sessionWithNewScoring.js";
import battingScopeContext from "../../../classificators/resultsSlice/battingScopeContext.js";
import RankingStatCaseVerifier from "../../../validators/RankingStatCaseVerifier.js";
import BatchResultsFormatter from "../../../formatters/resultsFormatters/BatchResultsFormatter.js";
import DefaultValuesFormatter from "../../../formatters/resultFormatters/DefaultValuesFormatter.js";
import StrikeZoneFrontFormatter from "../../../formatters/resultFormatters/StrikeZoneFrontFormatter.js";
import PropertyAssuranceFormatter from "../../../formatters/resultFormatters/PropertyAssuranceFormatter.js";
import GenericResultFormatter from "../../../formatters/resultsFormatters/GenericResultFormatter.js";
import StrikeZoneSectorFormatter from "../../../formatters/resultsFormatters/StrikeZoneSectorFormatter.js";
import CompositeResultsFormatter from "../../../formatters/resultsFormatters/CompositeResultsFormatter.js";
import SessionResultsStructureFormatter from "../../../formatters/resultsFormatters/SessionResultsStructureFormatter.js";
import ResultPair from "../../../valueObjects/ResultPair.js";
import NewPlateDisciplineStatsCalculator from "../../NewPlateDisciplineStatsCalculator.js";
import PlateDisciplineCalculator from "../PlateDisciplineCalculator.js";

class NewPlateDisciplineCalculator extends PlateDisciplineCalculator{
    constructor(
        context, strikeZoneModel, sessionResultsFormatter, customResultsProcessor,
        plateDisciplineStatsCalculator, rankingStatCaseVerifier, numberFormatter, skipCache, contextualResultFilter
    ) {
        super(
            context,
            strikeZoneModel,
            sessionResultsFormatter,
            customResultsProcessor,
            plateDisciplineStatsCalculator || new NewPlateDisciplineStatsCalculator(),
            rankingStatCaseVerifier || new RankingStatCaseVerifier(
                anyLeague, 
                sessionWithNewScoring,
                satisfiesAll(
                    context === RankingScopeContext.Pitching.key ? pitchingScopeContext: battingScopeContext,
                    resultsSliceForPitchType
                )
            ),
            numberFormatter,
            skipCache,
            contextualResultFilter
        );
    }

    buildDefaultFormatter() {
        const pitchFormatters = [
            new DefaultValuesFormatter(PitchData.StrikeZoneFront, [ResultDataNew.Data.key, DataSection.Sensor.key, ResultPair.getPitchProperty()])
                .registerReplacement('0; 0; 0', undefined)
                .registerReplacement(';;', undefined),
            StrikeZoneFrontFormatter.forNewStructure(),
        ];
        const hitFormatters = [];

        const formatters = [
            // see BBP-1132, we don't need to convert structure, as we use new PA stats calculator here, which handles it just fine
            // new SessionResultsStructureFormatter(true),
            // new BatchResultsFormatter(new PropertyAssuranceFormatter(
            //     [ResultDataNew.Data.key], (value) => (typeof(value) === 'object' && value !== null), {}
            // )),
            new GenericResultFormatter(pitchFormatters, hitFormatters, true),
            new StrikeZoneSectorFormatter(this.strikeZoneModel, true),
        ];

        return new CompositeResultsFormatter(...formatters);
    }
}

export default NewPlateDisciplineCalculator;